import config from '@config';
import { round as _round } from '@lodash';
import Decimal from 'decimal.js-light';

export default class CalculationHelper {
    public static round(value: number, numberOfDecimalPlaces: number = config.app.betSlip.decimalPlaces) {
        return _round(value, numberOfDecimalPlaces);
    }
}

export function calculateStakePerCombination(
    stake: number,
    numberOfCombinations: number) {
    return new Decimal(stake).div(numberOfCombinations || 1).toNumber();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/betSlip/CalculationHelper.ts